import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {orderSelector, setOrderFilter, resetOrderFilter} from '../../../redux/slices/orderSlices'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import { Button } from 'react-bootstrap'
import { hasFilterProps } from './helpers'

interface CardHeaderProps {
  wrapperStyle?: React.CSSProperties
  right?: React.ReactNode
  onReset?: () => void
}

export const CardHeader = (props: CardHeaderProps) => {
  const {orderFilter} = useAppSelector(orderSelector)
  const dispatch = useAppDispatch()

  const handlePageSizeChange = (value: number | undefined | null) => {
    dispatch(setOrderFilter({...orderFilter, per_page: value ?? 5}))
  }
  const handleResetFilter = () => {
    dispatch(resetOrderFilter())
  }

  const hasFilter = () => {
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-order-filter') as string)
      if(hasFilterProps(persisted)){
        return persisted
      }

      return null
    }catch(e){ return null }
  }

  return (
    <StyledButtonGroups
      leftContent={
        <>
          <SelectPageSize
            initialValue={orderFilter?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />

          { hasFilter() && <button type="button" onClick={() => handleResetFilter()} className="btn btn-outline-danger btn-sm">Clear Filter</button> }
        </>
      }
      rightContent={props.right}
    />
  )
}
